import { Toggle } from "@/components/ui/baseUi/toggle"
import { cn } from "@/modules/lib/utils"
import { shortenText } from "@/modules/utils/stringUtils"
import { BoxOfferItemEntity } from "@modules/boxOffer/entities/boxOfferEntity"
import { word } from "@modules/core/utils/i18n"
import { formatCurrency } from "@modules/currency/currency"
import { useLanguage } from "@modules/language/hooks/useLanguage"

type RestrictionTagProps = {
  boxOffer: BoxOfferItemEntity
  isSelected: boolean
  onSelectRestriction?: () => void
  className?: string
  textSize?: number
} & React.ComponentProps<typeof Toggle>

export function BoxRestrictionTag({
  boxOffer,
  isSelected,
  onSelectRestriction,
  className,
  textSize = 45,
  ...props
}: RestrictionTagProps) {
  const language = useLanguage()

  return (
    <Toggle
      key={"toggle-box-offer-" + boxOffer.id}
      pressed={isSelected}
      onPressedChange={onSelectRestriction}
      variant="emphasisLow"
      size="md"
      className={cn("items-center justify-start text-start", className)}
      title={`${boxOffer.name} - ${boxOffer.price ? formatCurrency(boxOffer.price.value, boxOffer.price.currency, language) : word("program.price.free")}`}
      {...props}
    >
      {boxOffer.name.length > textSize
        ? shortenText(
            `${boxOffer.name} - ${boxOffer.price ? formatCurrency(boxOffer.price.value, boxOffer.price.currency, language) : word("program.price.free")}`,
            textSize,
          )
        : `${boxOffer.name} - ${boxOffer.price ? formatCurrency(boxOffer.price.value, boxOffer.price.currency, language) : word("program.price.free")}`}
    </Toggle>
  )
}
